/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const updatePureWaveSettingRequestModelSchema = z.object({
    "trackFrequency": z.number().int().describe("Частота треков"),
"podcastFrequency": z.number().int().describe("Частота подкастов")
    })